import { useState } from "react";
import { AiFillFileAdd } from "react-icons/ai";
import { Link } from "react-router-dom";
import { RoutePath } from "../../../utility/Constant";

function BoardCard({ project, user, handleSingleDelete }) {
  const { aboutUsBoardList, aboutUsBoardListAdd } = RoutePath;
  const [visibility, setVisibility] = useState(true);

  const handleDelete = async () => {
    const res = await handleSingleDelete(project._id);
    if (typeof res === "boolean" && res === true) {
      setVisibility(false);
    }
  };

  return (
    <>
      {visibility ? (
        <div className="group">
          {project ? (
            <div className="border bg-base-100 shadow-lg rounded-lg overflow-hidden">
              <figure>
                <img
                  src={project?.image?.url}
                  alt={project.Name + " " + "Image"}
                  className="h-[150px] md:h-[300px] object-cover w-full"
                />
              </figure>

              <div className="p-3 flex flex-col gap-1">
                <div>
                  <span className="text-sm md:text-base leading-3 font-medium text-gray-900">
                    {project.Position}
                  </span>
                  <h2 className="text-base mt-2 md:text-lg font-semibold">
                    {project.Name}
                  </h2>
                </div>
              </div>
              <div className="p-3 flex justify-between gap-2 text-xs md:text-base mt-2 border-t">
                <Link
                  to={`/${aboutUsBoardList}/${project._id}`}
                  className="btn btn-outline btn-xs border-blue-500 text-blue-500 hover:bg-blue-500 hover:border-blue-500 hover:text-white py-2 w-24 transition duration-150 border text-center rounded-lg"
                >
                  Edit
                </Link>
                {user === "admin" && (
                  <button
                    id={project._id}
                    onClick={handleDelete}
                    className="btn btn-outline btn-xs border-red-500 text-red-500 hover:bg-red-500 hover:border-red-500 hover:text-white py-2 w-24 transition duration-150 border text-center rounded-lg"
                  >
                    Delete
                  </button>
                )}
              </div>
            </div>
          ) : (
            <Link
              to={`/${aboutUsBoardListAdd}`}
              className="flex justify-center items-center rounded-xl bg-gray-50 shadow-xl h-full "
            >
              <p className="text-8xl group-hover:text-primary">
                <AiFillFileAdd />
              </p>
            </Link>
          )}
        </div>
      ) : null}
    </>
  );
}

export default BoardCard;
